import React, { FC } from "react";
import { Typography } from "@material-ui/core";
import pretty from "Shared/pretty";
import { DPEmployeeProfile } from "Shared/types/EmployeeProfiles";
import DataTable from "Components/Shared/DataTable/DataTable";
import DataTableRow from "Components/Shared/DataTable/DataTableRow/DataTableRow";
import useStyles from "./styles";

type Props = {
  employee: DPEmployeeProfile["employee"];
}

const ContactInfoTable: FC<Props> = ({ employee }) => {
  const classes = useStyles();

  return (
    <DataTable title="Contact Info">
      <DataTableRow>
        <Typography>Email:</Typography>
        <Typography className={classes.detail}>
          {employee.hasPlaceholderEmail ? "No Email" : employee.email}
        </Typography>
      </DataTableRow>
      <DataTableRow>
        <Typography>Phone Number:</Typography>
        <Typography className={classes.detail}>
          {pretty.phone(employee.phoneNumber || "")}
        </Typography>
      </DataTableRow>
    </DataTable>
  );
};

export default ContactInfoTable;
